/**
 * @file routes.ts
 *
 * @fileoverview Include routes for the application.
 */
const jobiqoRoutesConfig = require('./../routes');
const R = require('ramda');

module.exports = R.mergeDeepRight(jobiqoRoutesConfig, {
  routes: [...jobiqoRoutesConfig.routes],
  frontendSpecificRedirects: [
    ...jobiqoRoutesConfig.redirects,
    // robots.txt redirect
    {
      source: '/robots.txt',
      destination: `/static/dhg/robots.txt`,
      permanent: false,
    },
  ]
});
